import React, { createContext, useState, useEffect } from 'react';

export const BillContext = createContext();

export const BillProvider = ({ children }) => {
    const tax = 0.1;

    const [baseAmount, setBaseAmount] = useState(0); // Giá không có thuế
    const [totalAmount, setTotalAmount] = useState(0); // Giá có thuế
    const [taxAmount, settaxAmount] = useState(0);
    // const [priceAdd, setpriceAdd] = useState(0);
    // const [pricebackup, setpricebackup] = useState(null);
    const [backupPrice, setbackupPrice] = useState(0);
    const [pricepermonth, setpricepermonth] = useState(0);
    const [postdiscount, setpostdiscount] = useState(0);

    const calculateTotal = (selectedPackage, selectedCycle, pricebackup, pricekm, backup) => {
        // if (!selectedPackage || !selectedPackage.periods || !selectedCycle || !selectedFeatures) {
        //     setBaseAmount(0);
        //     setTotalAmount(0);
        //     settaxAmount(0);
        //     return;
        // }

        console.log("pricebackupNE", pricebackup?.price)

        // if (selectedFeatures) {
        //     const totalFeaturePrice = selectedFeatures.reduce((total, feature, index) => {
        //         const price = index === 0
        //             ? pricepermonth * 0.2 || 0 
        //             : feature?.price || 0;    
        //         return total + price;         
        //     }, 0);

        //     setpriceAdd(totalFeaturePrice);
        // }

        if (pricebackup) {
            setbackupPrice(pricebackup?.price);
        }

        const pricePerMonth = selectedCycle?.price;

        // console.log("pricePerMonth", pricePerMonth)

        if (pricePerMonth !== undefined) {
            setpricepermonth(pricePerMonth)

        } else {

        }
        const pricePerPeriod = pricePerMonth * selectedCycle?.months;
        if (pricePerPeriod !== undefined) {
        } else {
            // console.error("Chu kỳ được chọn không tồn tại trong object.");
        }
        // console.log("pricekm", pricekm)
        // let backupPrice = 0;
        // if (backup === 'day') {
        //     backupPrice = pricePerMonth * 0.2; 
        // } else if (backup === 'week') {
        //     backupPrice = pricePerMonth * 0.2; 
        // }
        // let backupPerPeriod = backupPrice * selectedCycle?.months;

        let subtotal = 0;
        if (pricebackup?.isSelected == true) {
            subtotal = pricePerPeriod + (pricebackup?.price * selectedCycle?.months);

        }
        else {
            subtotal = pricePerPeriod;

        }
        console.log("subtotal", subtotal)

        const postdiscount = subtotal + (pricekm);
        // console.log("postdiscount", postdiscount)
        setpostdiscount(postdiscount)
        const pricetax = subtotal * 0.1;
        // console.log("pricetax", pricetax)

        const total = postdiscount;

        // Lấy chu kỳ đã chọn từ `periods`

        // if (!selectedPeriod) {
        //     setBaseAmount(0);
        //     setTotalAmount(0);
        //     settaxAmount(0);
        //     return;
        // }

        // const pricePerMonth = parseFloat(selectedPeriod?.price?.total || 0);
        // const durationInMonths = getCycleMonths(selectedPeriod.name);

        // var basePrice = (pricePerMonth * durationInMonths) + priceAdd;


        // var tamtinh = basePrice + pricekm;
        // console.log("tamtinh", tamtinh)
        // const calculatedTax = (basePrice * tax);

        // const totalPrice = basePrice + calculatedTax;

        // console.log("priceAdd", priceAdd)
        settaxAmount(pricetax);
        setBaseAmount(subtotal);
        setTotalAmount(total);
        // setbackupPrice(backupPrice)
    };

    // const getCycleMonths = (cycleName) => {
    //     const cycleMapping = {
    //         Monthly: 1,
    //         Quarterly: 3,
    //         Biannually: 6,
    //         Annually: 12,
    //         Biennially: 24,
    //         Triennially: 36,
    //     };
    //     return cycleMapping[cycleName] || 0; // Trả về 0 nếu không tìm thấy chu kỳ
    // };

    return (
        <BillContext.Provider value={{ baseAmount, totalAmount, calculateTotal, taxAmount, postdiscount, backupPrice }}>
            {children}
        </BillContext.Provider>
    );
};
